import { Flex, Text } from '@chakra-ui/core'
import * as React from 'react'
import { useMediaQuery } from 'react-responsive'
import { Link } from 'react-router-dom'
import useBreadcrumbs from 'use-react-router-breadcrumbs'
import { PRIVATE_ROUTES } from '../../navigation/routes'

const Breadcrumbs = () => {
  const breadcrumbs = useBreadcrumbs(PRIVATE_ROUTES)
  const slicedBreadcrumbs = breadcrumbs.slice(2)
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 40em)' })

  return (
    <Flex justify="center" align="center">
      {isTabletOrMobile ? (
        <React.Fragment>
          <Text fontSize={18} fontWeight="bold" color="white">
            {slicedBreadcrumbs.slice(-1)[0].breadcrumb}
          </Text>
        </React.Fragment>
      ) : (
        slicedBreadcrumbs.map(({ breadcrumb, match }, index) => {
          return (
            <React.Fragment key={match.url}>
              <Link to={match.url || ''}>
                <Text fontSize={16} fontWeight="bold" color="gray.700">
                  {breadcrumb}
                </Text>
              </Link>
              {index < slicedBreadcrumbs.length - 1 && (
                <Text fontSize={18} fontWeight="bold" mx={2} color="gray.400">
                  /
                </Text>
              )}
            </React.Fragment>
          )
        })
      )}
    </Flex>
  )
}

export default Breadcrumbs
